const AUTH_HINT_COOKIE = 'fastri_has_session';

export function setAuthHint(): void {
  document.cookie = `${AUTH_HINT_COOKIE}=1; path=/; max-age=31536000; SameSite=Lax`;
}

export function clearAuthHint(): void {
  document.cookie = `${AUTH_HINT_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}

export function hasAuthHint(): boolean {
  return document.cookie.includes(`${AUTH_HINT_COOKIE}=1`);
}
